import { Location, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { BaseFormComponent } from 'components/form/base-form';
import { SearchClientInputComponent } from 'components/search-client-input/search-client-input.component';
import { Tab, TabsComponent } from 'components/tabs/tabs.component';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { ApiService } from 'services/api.service';
import { ToastService } from 'services/toast.service';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { ClientCard } from 'types/client.interface';
import { getControlsWithErrors } from 'util/form.utility';

@Component({
  selector: 'app-create-info-request-page',
  standalone: true,
  imports: [BreadcrumbsComponent, TranslateModule, SearchClientInputComponent, ReactiveFormsModule, NgClass, TooltipComponent, TabsComponent],
  templateUrl: './create-info-request-page.component.html',
  styleUrls: ['./create-info-request-page.component.scss', '../../components/form/base-form.scss']
})
export class CreateInfoRequestPageComponent extends BaseFormComponent {
  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.infoRequest',
      url: '/informacijas-pieprasijums'
    },
    {
      title: 'components.breadcrumbs.infoRequestApply',
      url: ''
    }
  ];

  selectedClient: ClientCard | null = null;
  activeTab: 'fp' | 'jp' = 'fp';
  tabs: Tab[] = [
    { key: 'fp', label: 'pages.createInfoRequest.fpTab' },
    { key: 'jp', label: 'pages.createInfoRequest.jpTab' }
  ];

  constructor(
    protected override location: Location,
    protected override router: Router,
    protected override formBuilder: FormBuilder,
    protected override apiService: ApiService,
    protected override toastService: ToastService,
    protected override translateService: TranslateService
  ) {
    super(location, router, formBuilder, apiService, toastService, translateService);
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      clientId: [null, [Validators.required]]
    });
  }

  setActiveTab(tab: 'fp' | 'jp'): void {
    this.activeTab = tab;
    this.selectedClient = null;
    this.form.get('clientId')?.setValue(null);
  }

  createApplication(): void {
    this.submitAttempted = true;

    if (this.form.valid && this.selectedClient) {
      this.submitAttempted = false;
      const clientId = this.form.get('clientId')?.value;
      const clientType = this.activeTab === 'jp' ? 2 : 1;
      const legalEntityId = this.activeTab === 'jp' ? this.selectedClient?.legalEntityId : undefined;
      this.router.navigate([`/${clientId}/pakalpojumi/informacijas-pieprasijums`], {
        queryParams: { clientType, ...(legalEntityId && { legalEntityId }) }
      });
    } else {
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'pages.createInfoRequest');
    }
  }

  onClientSelected(client: ClientCard | null): void {
    this.selectedClient = client ?? null;
    this.form.get('clientId')?.setValue(client?.id ?? null);
  }

  getFirstName(): string {
    if (!this.selectedClient?.fullName) return '';
    const parts = this.selectedClient.fullName.split(' ');
    if (parts.length <= 1) return this.selectedClient.fullName;
    return parts.slice(0, -1).join(' ');
  }

  getLastName(): string {
    const parts = this.selectedClient?.fullName?.split(' ');
    return parts ? parts[parts.length - 1] : '';
  }

  getAuthenticationTypeName(name: string | undefined): string {
    switch (name) {
    case 'Local':
      return 'Izveidojis LNA darbinieks';
    case 'NationalId':
      return 'Latvija LV';
    case 'Email':
      return 'E-pasts';
    default:
      return name || '-';
    }
  }
}
